import React from 'react';

const SidebarClientsIcon: React.FC<{ active: boolean }> = ({ active }) => {
  if (active) {
    return (
      <svg
        width="33"
        height="28"
        viewBox="0 0 33 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.1176 16.4706C21.7562 16.4706 24.7059 19.4203 24.7059 23.0588V25.5294C24.7059 26.8938 23.5997 28 22.2353 28H2.47059C1.10612 28 0 26.8938 0 25.5294V23.0588C0 19.4203 2.94965 16.4706 6.58824 16.4706H18.1176ZM28 16.4709C30.729 16.4709 32.9412 18.6832 32.9412 21.4121V23.8827C32.9412 25.2473 31.835 26.3533 30.4706 26.3533H28V23.0588C28 20.3651 26.7067 17.9735 24.7072 16.4709H28ZM12.3529 0C16.4464 0 19.7647 3.31836 19.7647 7.41177C19.7647 11.5052 16.4464 14.8235 12.3529 14.8235C8.25954 14.8235 4.94118 11.5052 4.94118 7.41177C4.94118 3.31836 8.25954 0 12.3529 0ZM26.3529 4.94118C29.082 4.94118 31.2941 7.15342 31.2941 9.88235C31.2941 12.6114 29.082 14.8235 26.3529 14.8235C23.6239 14.8235 21.4118 12.6114 21.4118 9.88235C21.4118 7.15342 23.6239 4.94118 26.3529 4.94118Z"
          fill="#C1FE40"
        />
      </svg>
    );
  } else {
    return (
      <svg
        width="33"
        height="28"
        viewBox="0 0 33 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.1176 16.4706C21.7562 16.4706 24.7059 19.4203 24.7059 23.0588V25.5294C24.7059 26.8938 23.5997 28 22.2353 28H2.47059C1.10612 28 0 26.8938 0 25.5294V23.0588C0 19.4203 2.94965 16.4706 6.58824 16.4706H18.1176ZM28 16.4709C30.729 16.4709 32.9412 18.6832 32.9412 21.4121V23.8827C32.9412 25.2473 31.835 26.3533 30.4706 26.3533H28V23.0588C28 20.3651 26.7067 17.9735 24.7072 16.4709H28ZM12.3529 0C16.4464 0 19.7647 3.31836 19.7647 7.41177C19.7647 11.5052 16.4464 14.8235 12.3529 14.8235C8.25954 14.8235 4.94118 11.5052 4.94118 7.41177C4.94118 3.31836 8.25954 0 12.3529 0ZM26.3529 4.94118C29.082 4.94118 31.2941 7.15342 31.2941 9.88235C31.2941 12.6114 29.082 14.8235 26.3529 14.8235C23.6239 14.8235 21.4118 12.6114 21.4118 9.88235C21.4118 7.15342 23.6239 4.94118 26.3529 4.94118Z"
          fill="white"
        />
      </svg>
    );
  }
};

export default SidebarClientsIcon;
